<template>
<body>
    <BasicLayouts>
    <div class="main-container">
        <main class="main">
            <!--main es una etiqueta contextual -->
            <div class="text">
                <!--es de tipo texto-->
                <h1>LA MEJOR COMIDA ESTA AQUI!</h1>
                <!--Es el tiutlo headline1 = h1-->
                <p class="subtitulo">
                    <!--es un parrafo-->
                    Te Antojaste de comer algo delicioso?, aqui lo encuentras!
                </p>
                <div class="slider-container">
                    <div class="slider" id="slider">
                    
                    <div class="slider-section">
                        <img class="img-slider" src="../assets/combo_2x1.jpg" alt="combo 2x1">
                    </div>
                    <div class="slider-section">
                        <img class="img-slider" src="../assets/Fast-food-combo.jpg" alt="Combo fast food">
                    </div>
                    <div class="slider-section">
                        <img class="img-slider" src="../assets/Fast-food-combo-1.jpg" alt="Combo fast food 1">
                    </div>
                    <!--<p>&#60;</p>--><!--#62=simbolo menor "<"-->
                    <!--<p>&#62;</p>--><!--#68= simbolo mayor ">"-->
                    </div>
                
                    <input type="radio" id="1" name="input-slide" hidden/>
                    <input type="radio" id="2" name="input-slide" hidden/>
                    <input type="radio" id="3" name="input-slide" hidden/>
                
                    <div class="navigation">
                    <label class="navigation-item" for="1">
                        <img class="img-slider" src="../assets/combo_2x1.jpg" alt="">
                    </label>
                    <label class="navigation-item" for="2">
                        <img class="img-slider" src="../assets/Fast-food-combo.jpg" alt="">
                    </label>
                    <label class="navigation-item" for="3">
                        <img class="img-slider" src="../assets/Fast-food-combo-1.jpg" alt="">
                    </label>
                    <!--<p>&#60;</p>--><!--#62=simbolo menor "<"-->
                    <!--<p>&#62;</p>--><!--#68= simbolo mayor ">"-->
                    </div>
                    <!--<div id="left-btn" class="slider-btn"><p><i class="fas fa-arrow-circle-left"></i></p></div>
                    <div id="right-btn" class="slider-btn"><p><i class="fas fa-arrow-circle-right"></i></p></div>-->
                </div>
            </div>

                <h2>Ultimos Productos</h2>
                <div class="ui grid">
                    <div 
                    class="sixten wide mobile eight wide tablet four wide computer column"
                    v-for="product in products" :key="product.id"
                    >
                        <product :product="product" />
                    </div>
                </div>
        </main>
        <aside class="aside-container">
            <h1 style="text-align: center; color: #000;">aside</h1>
        </aside>
        <footer>
            <div>
                <p>
                    Contacto y derechos reservados 2021 @S.A
                </p>
            </div>
        </footer>
    </div>
    </BasicLayouts>
</body>
</template>

<script>
import { ref, onMounted } from 'vue';
import { getProducts } from '../api/product'
import BasicLayouts from '../layouts/BasicLayouts.vue';
import Product from '../components/Product.vue';
export default {
    name:'Home',
    components:{
        BasicLayouts,
        Product
    },

    setup(){
        let products= ref(null);

        onMounted(async()=>{
            const response = await getProducts(20);
            products.value =response;
            //console.log(response);
        });
        return{
            products
        };
    },
};
</script>

<style  scoped>
  * {
    box-sizing: border-box;
    padding: 0;
    /* espacion interior en cada elemento*/
    margin: 0;
    /* espacion exterior en cada elemento*/
    /*border: solid 1px #000; para ver como estan las alineaciones  */
}
    body{
    background-image: url(../assets/fondo.png); /*ruta de la imagen ../ pra que sea desde arriba*/    
    background-repeat: no-repeat;  /* para que no se repita la imagen */
    background-position: center center;/*posicionar background*/
    background-size: cover;/* ajustar imagen a contenedor*/
    background-attachment: fixed;
}

.main-container{
    border-radius: 25px, #000;
    font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
    margin: 0 auto;
    width: 100%;
    color: #fff;/*color de letra blanco*/
    display: grid; /*Aplicacion grid para pagina responsiva*/
    grid-gap:10px;/*Espaciado entre grillas*/
    grid-template-columns: repeat(3,1fr); /*columnas, cada una flexible*/
    grid-template-rows: repeat(3,auto); /*filas, cada una centrada automaticamente*/
}
/*----------------------------CONTENIDO PRINCIPAL--------------------------------*/
.main{
    padding: 10px 20px;
    grid-column: 1/4;
    display: flex;
    justify-content: center;
    flex-direction: column;/*direccion en columna del contenido en el main*/
}

main .text >h1 {
    /*titulo */
    border-radius: 10rem;
    padding: 30px 10px;
    color: yellow;
    background-color:  rgba(250, 6, 6, 0.616);
    text-align: center;
    font-size: 70px;
}
main .text >.subtitulo{
    border-radius: 10rem;
    padding: 30px 10px;
    margin: 20px 0;
    color: red;
    background-color:  rgba(116, 250, 6, 0.616);
    text-align: center;
    font-family:monospace ;
    font-size: 30px;
}
main >h2{
    border-radius: 10rem;
    padding: 30px 10px;
    color: yellow;
    background-color:  rgba(250, 6, 6, 0.616);
    text-align: center;
    font-style: bold;
    font-size: 30px;
}
main .text >p{
    /*parrafo*/
    font-size: 20px;
    padding: 20px 0;
}
.main  button {
    /*background-color: #72e624;*/
    background-color: rgba(250, 6, 6, 0.616);/*Cambio de color al div del button de mejor apariencia*/
    border: 10;
    /*quita el borde */
    border-radius: 8px;
    color: white;
    cursor: pointer;
    font-size: 30px;
    padding: 20px 20px;
    margin: 10px;
}
button:hover {
    background-color: #14929b;
}
.image{
    background-image: url(../assets/comidas_rapidas.png);
    border-radius: 20px;
    padding: 20px 10px;
}
/*---------------------------------SLIDER--------------------------------------*/

.slider-container{
    grid-column: 1/4;
    overflow: hidden; 
    border-radius: 10rem;
    box-shadow: 0 0 0 10px #48e,
                0 15px 50px;
    position: relative;
    margin-bottom: 20px;
}
.slider{
    display: flex;
    height: 600px;
    width: 300%;

    transition: all 6s;
    animation-name: change;
    animation-duration: 15s;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-timing-function: ease-out;
}
.slider-section{
    position: relative;
    display: flex;
    flex-direction: column;

    width: 90%;
}
.img-slider{
    display: block;
    width: 100%;
    height: 100%;
    object-fit:contain cover;
    object-position: center center;
}
/*.slider-btn{
    color: #000;
    font-size: 30px;
    font-weight: bold;
    font-family: monospace;
    position: absolute;
    width: 40px;
    height: 40px;
    background-color: #fff;
    top: 50%;
    transform: translateY(-50%);
    margin: auto;
    text-align: center;
    border-radius: 50%;
    cursor: pointer;
}*/
@keyframes change {

    0%{margin-left: 0;}
    20%{margin-left: 0;}

    25%{margin-left: -100%;}
    45%{margin-left: -100%;}

    50%{margin-left: -200%;}
    70%{margin-left: -200%;}
}
.navigation{
    position: absolute;
    bottom: 30px;
    left: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    width: 100%;
}
.navigation-item{
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 3px solid darkviolet;
    border-radius: 4px; 
    width: 40px;
    height: 40px;
    cursor: pointer;
    margin-left: 10px;
    overflow: hidden;
    transition: all 300ms;
}
.navigation-item:hover{
    transform: scale(2);
}
.navigation-item > img{
    display: inline-block;
    height: 100%;
    max-width:none;
    transform:scale(1);
    opacity: 0;
    transition: all 300ms;
}
.navigation-item:hover img{
    opacity: 1;
    transform:scale(1);
}


.slider-btn:hover{
    background-color: darkgray;
}
#left-btn{
    left: 10px;
}
#right-btn{
    right: 10px;
}
/*-------------------------------------------------------------------------------*/

/*-------------------------------PRODUCTS------------------------------------*/
.ui.grid{
    margin: 20px 0;
    background-color: #48e;
    border-radius: 20px;
}

/*-------------------------------------ASIDE---------------------------------------*/
.aside-container{
    margin-right: 10px;
    background-color: chartreuse;
    grid-column: 1/4;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
}
/*--------------------------------FOOTER---------------------------------------------*/
footer{
    background-image: url(../assets/bradcam.png);
    grid-column: 1/4;
    display: flex;
    justify-content: center;
}
footer >div{
    justify-self: center;
}
footer div >p{
    font-size: 20px;
}
/*------------------------------------pagina responsiva---------------------------------------*/
@media screen and (max-width:600px) {
/*------------------------------HEADER----------------------------*/
header, .main, footer, aside{
    grid-column: 1/4;
}
.aside-container{
    width: 100%;
    grid-column: 1/4;
}
    #logo{
        justify-content: center;
        grid-column: 1/4;
    }
#logo >a{
    padding-left: 1px;
}
/*-----------------------------------MAIN CONTAINER------------------------------*/

main .text >h1{
    font-size: 25px;
}
main >.subtitulo{
    font-size: 15px;
    padding: 30px 10px;
}
.slider{
    height: 500px;
}
}
</style>
